var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    attrs: {
      id: "unsaved-changes-modal",
      "modal-dialog-scrollable": false,
      "loaders-disabled": "",
      "modal-dialog-size": "md",
      "footer-close-button-text": _vm.$t("global.words.no"),
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("lists.messages.deleteAllContacts")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "pb-4" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("lists.messages.confirmDeleteAllContacts")) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: {
                  id: "delete-button",
                  "class-name": "btn btn-danger",
                  type: "danger",
                  loading: _vm.deletingAllContacts.loading,
                  "loading-succeeded": _vm.deletingAllContacts.status,
                },
                on: { click: _vm.handleConfirm },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("global.messages.yesRemoveAll")) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }